import { Site } from '@envato/foundation-types'
import * as React from 'react'

import FeatureContainer from '../../containers/feature/featureContainer'
import AudioJungleItemCard from './audioJungleItemCard'
import DefaultItemCard from './defaultItemCard'
import GraphicRiverItemCard from './graphicRiverItemCard'
import NarrowItemCard from './narrowItemCard'
import PhotoduneGridItemCard from './photoduneGridItemCard/photoduneItemCardContainer'

import { IProps } from './itemCardContainer'

const ItemCard = ({ currentSite, ...props }: IProps): any => {
  if (currentSite === Site.photodune) {
    return <PhotoduneGridItemCard {...props} />
  } else if (currentSite === Site.graphicriver) {
    return <GraphicRiverItemCard {...props} />
  } else if (currentSite === Site.audiojungle) {
    return <AudioJungleItemCard {...props} />
  }

  return [
    <FeatureContainer key="narrowItemCard" name="narrowItemCard">
      <NarrowItemCard {...props} />
    </FeatureContainer>,
    <FeatureContainer key="!narrowItemCard" name="!narrowItemCard">
      <DefaultItemCard {...props} />
    </FeatureContainer>
  ]
}

export default ItemCard
